import axios from 'axios';
import { message } from 'antd';
import { axiosApiInstance } from '../../services/axiosApiInstance';

const api = `${process.env.REACT_APP_API_URL}/api/v1/devices/listAllDevices`;

export interface DataType {
    site_name: string;
    deviceType: string;
    name: string;
    status: string;
    operationalState: string;
    ipAddress: string;
    macAddress: string;
    model: string;
    serialNumber: string;
    uptimeInSeconds: number;
    wiredClientsCount: number;
    numberOfSecondsSinceLastCommunication: number;
}

async function getDeviceData() {
    try {
        const getItem = await axiosApiInstance.get(api);
        return getItem?.data
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.data.detail) {
                if (error.response.status !== 401) {
                    const msg = error.response.data.detail
                    message.error(msg, 5);
                }
            }
        } else {
            message.error("Some error occurred", 5);
        }
    }
}

async function getDeviceDataWithFilters(filter_string: string) {
    const allowed_filters = ["status"]
    try {
        let filters = '';
        if (filter_string) {
            const params = new URLSearchParams(filter_string)            

            for (const [key, value] of params) {
                if (allowed_filters.includes(key)) {
                    filters += (filters==='') ? `${key}=${value}` : `&${key}=${value}`
                }                
            }
        }      
        
        const getItem = await axiosApiInstance.get(`${api}?${filters}`)
        return getItem?.data
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.data.detail) {
                if (error.response.status !== 401) {
                    const msg = error.response.data.detail
                    message.error(msg, 5);
                }
            }
        } else {
            message.error("Some error occurred", 5);
        }
    }
}

export {
    getDeviceData,
    getDeviceDataWithFilters
}